
import React from 'react';
import {Action, DashboardContainer, Spinner} from "../../funcs/utils";
import {FlowRender} from "../../../lib/flow-render";
import {NewUserDialog} from "./new-user-dialog";
import {AccountState} from "../../../lib/constants";
import {DashboardTable} from "../dashboard-table";
import {adminAddAccount} from "../SA_UserPortfolios/actions";
import {onboarding_start_segment} from "../../../lib/onboarding-utils";
import {sprintf} from "sprintf-js";
import {
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ENVELOPE_ID,
  ELECTRONIC_SIGNING_TYPE,
  ACCOUNT_NUMBER
} from "../SA_UserPortfolios/prm";
import {ProxyDocumentDelivery} from "../../../lib/docusign-constants";

const ALL_PRMS = new FlowRender(0, [
  FIRST_NAME,
  LAST_NAME,
  EMAIL,
  ENVELOPE_ID,
  ELECTRONIC_SIGNING_TYPE,
  ACCOUNT_NUMBER,
]);


const USER_STATES = {
  UNKNOWN: "UNKNOWN",

  // Entering new user's information.
  ONBOARDING: "ONBOARDING",

  // Envelope created, email to recipient
  OUT_FOR_SIGNATURE: "OUT FOR SIGNATURE",

  // Doc has been signed
  SIGNED: "SIGNED",

}

const ProcessUsers = (component, users) => {
  users.forEach((user, index) => {
    const onboarding = user.onboarding;
    const delivery_type = onboarding.docusign_delivery_type;
    const has_envelope_id = !!onboarding.envelope_id;
    if (
      (user.account_state === AccountState.ONBOARDING_PROXY && !has_envelope_id)
      || (user.account_state === AccountState.ONBOARDING_PROXY && has_envelope_id
        && delivery_type === ProxyDocumentDelivery.SIGNED)) {
      user.state = USER_STATES.ONBOARDING;
    } else if (user.account_state === AccountState.ONBOARDING_PROXY && onboarding.envelope_id)  {
      user.state = USER_STATES.OUT_FOR_SIGNATURE;
    } else if (user.account_state === AccountState.SIGNED_PROXY) {
      user.state = USER_STATES.SIGNED;
    } else {
      user.state = USER_STATES.UNKNOWN;
    }
    user.index = index;

    if (user.onboarding) {
      component.props.setOnboardingData(user.onboarding, user.account_index, user.username);
    }
    if (user.tda) {
      component.props.tdaUpdate(user.tda, user.account_index, user.username);
    }
    if (user.dwolla) {
      component.props.dwollaUpdate(user.dwolla, user.account_index, user.username);
    }
  })
}

const dump_menu = (component, item) => {
  const wlf = component.props.app.wlf;
  const buttons = [
    { id: "action", label: "" },
    { id: "onboarding", label: "Onboarding"},
    { id: "add_account", label: "Add Account"},
  ]
  const on_change = ev => {
    if (ev.target.value === "onboarding") {
      const onboarding = component.getOnboardingData(item.username, item.account_index);
      const no_envelope = onboarding.docusign_delivery_type === ProxyDocumentDelivery.NO_ENVELOPE;
      const segment = onboarding_start_segment(wlf);
      const url = sprintf(
        "/wlf-admin/onboarding_%04d/%s",
        item.account_index, no_envelope ? "personal_info" : segment);
      const args = {
        username: item.username,
        identity_id: item.identity_id,
        account_state: item.account_state,
        acct_index: sprintf("%d", item.account_index),
      }
      component.props.navigatePath(url, args);
    } else if (ev.target.value === "add_account") {
      component.setState({creating_user: true});
      adminAddAccount(component.props.token, item.username)
        .then(result => {
          if (result.success) {
            component.doLoadProxyOnboarding();
          } else {
            component.setState({creating_user: false});
            console.log("Fail");
          }
        })
    }
  }

  return (
    <select
      onChange={on_change}>
      { buttons.map(button => {
        return (<option key={button.id} value={button.id}>{button.label}</option>);
      })}
    </select>);
}

const dump_table = (component, items) => {
  const data = [
    [ "Name", "Email", "Account", "Account Type", "State", "Action" ],
  ];

  for(let i=0; i < items.length; i++) {
    const item = items[i];
    const line = [
      item.account_index === 0 ? item.name : "",
      item.account_index === 0 ? item.email : "",
      item.account || (<div align={"center"}><Spinner/></div>),
      item.account_type || "--PENDING--",
      item.state,
      dump_menu(component, item),
    ];
    data.push(line);
  }

  const style = {
    width: "100%",
  }
  const style_lut = [
    // Vertical lines
    {
      pred: () => true,
      style: {
        borderLeft: "solid 1px black",
        borderRight: "solid 1px black",
        paddingLeft: "0.3rem",
      }
    },
    // Header top/bottom borders
    {
      pred: (row) => row === 0,
      style: {
        borderTop: "solid 1px black",
        borderBottom: "solid 1px black",
        backgroundColor: "#EEE",
      }
    },
    // Bottom row
    {
      pred: (row) => row === items.length,
      style: {
        borderBottom: "solid 1px black",
      }
    },
    {
      // Start of new row of account has horizonal line
      pred: (row) => row > 0 && items[row - 1].account_index === 0,
      style: {
        borderTop: "solid 1px black",
      }
    }
  ]
  return (
    <DashboardTable
      data={data}
      tdStyleLut={style_lut}
      tableStyle={style}/>
  )
}

const onChange = (component, state) => {
  ENVELOPE_ID.setDisabled(
    state, ELECTRONIC_SIGNING_TYPE.getValue(state).id !== "signed");
}

const OnboardingProxyDashboard = props => {

  const component = props.component;
  const items = component.state.onboarding_users;

  ELECTRONIC_SIGNING_TYPE.onChangeCallback = onChange;
  onChange(component, component.state, ELECTRONIC_SIGNING_TYPE);

  const prms = { FIRST_NAME, LAST_NAME, EMAIL, ENVELOPE_ID, ELECTRONIC_SIGNING_TYPE, ACCOUNT_NUMBER};
  let dialog;

  if (component.state.show_new_user_dialog) {
    dialog =
      (<NewUserDialog
        prms={prms}
        component={component}/>);
  } else if (component.state.show_new_user_account_dialog) {
    dialog =
      (<NewUserDialog
        show_acct={true}
        prms={prms}
        component={component}/>);
  }

  const on_click = () => {
    component.setState({
      show_new_user_dialog: true,
    })
  }

  const spinner = component.state.onboarding_loading ? (
    <div align={"center"} style={{paddingTop: "2rem"}} >
      <Spinner size={"3rem"}/>
    </div>
  ) : null;
  const create_user_button = (
    <div style={{display: "flex", width: "100%"}}>
      <div style={{flex: "1"}}/>
      <div>
        <Action onClick={on_click}>
          Create New User
        </Action>
      </div>
    </div>
  );

  return (
    <DashboardContainer
      client={props.client}
      header={create_user_button}
      title={"Proxy Onboarding"}>
      <div style={{height: "2rem"}}/>
      { dump_table(component, items) }
      { dialog }
      { spinner }
    </DashboardContainer>
  )
};

const InitOnboarding = (component) => {
  const new_state = {
    show_new_user_dialog: false,
    show_new_user_account_dialog: false,
    new_user_error: "",
    highlight_rects: [],
    creating_user: false,
    onboarding_loading: false,
  };
  ALL_PRMS.init(new_state, {}, component);
  component.new_user_dialog_ref = React.createRef();
  return new_state;
}


export { OnboardingProxyDashboard, InitOnboarding, ProcessUsers, USER_STATES };
